
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'

export default defineComponent({
  components: {},
  data() {
    return {
      userId: '',
      hashKey: '',
      loading: false,
      result: {} as any
    }
  },
  async beforeMount() {
    this.userId = this.$route.params.user_id as string
    this.hashKey = this.$route.params.hash_key as string
    this.loading = true
    this.result = await hemisphereService.revokeUserCompany(this.userId, this.hashKey)
    this.loading = false
  }
})
